// ---------------------------------------------------- TOPS TEN ---------------------------------------------------- //

// function to retrieve all needed tops of a given store and field
export function getTopTen(store, field) {
  var topTen = []
  var selected = []
  var allInfo

  // establish connection with the database
  const request = window.indexedDB.open("ioScience", window.version)
  request.onsuccess = function() {
    const db = request.result
    const transaction = db.transaction(store, "readwrite")
    const mapInfo = transaction.objectStore(store)
    const all = mapInfo.getAll()

    all.onsuccess = function() {
      allInfo = all.result

      // select relevant information from the retrieved query
      for (var k = 0; k < allInfo.length; k++) {
        selected.push({ count: allInfo[k].value["Facts.count"], field: allInfo[k].value[field] })
      }
      selected.sort(function(a, b) {
        return b.count - a.count
      })
      for (let i = 0; i < 10; i++) {
        topTen.push(selected[i].field)
      }
    }
    db.close()
  }
  return topTen
}

export var topTenActivities = getTopTen("activityQuery", "Activity.activity")
export var topTenCategories = getTopTen("categoryQuery", "Activity.category")
export var topTenGroups = getTopTen("groupsQuery", "Bridge.idGroup")
export var topTenCaeCirs = getTopTen("caecirsQuery", "CaeCirs.code")

// ------------------------------------------------- PIE GROUP JOBS ------------------------------------------------- //

// function to retrieve top ten most common job groups through the companies connected - COUNTS
export function getGroupsTen() {
  var groupsTen = []
  var allInfo

  // establish connection with the database table
  const request = window.indexedDB.open("ioScience", window.version)
  request.onsuccess = function() {
    const db = request.result
    const transaction = db.transaction("groupsQuery", "readwrite")
    const info = transaction.objectStore("groupsQuery")
    const all = info.getAll()

    all.onsuccess = function() {
      allInfo = all.result

      // select relevant information from the retrieved query
      for (var k = 0; k < allInfo.length; k++) {
        if (topTenGroups.includes(allInfo[k].value["Bridge.idGroup"])) {
          groupsTen.push(allInfo[k].value["Facts.count"])
        }
      }
    }
    db.close()
  }
  return groupsTen
}

// function to retrieve top ten most common job groups through the companies connected - GROUP NUMBER
export function getJobsDesc() {
  var groupsTenDescriptions = []
  var allInfo

  // establish connection with the database table
  const request = window.indexedDB.open("ioScience", window.version)
  request.onsuccess = function() {
    const db = request.result
    const transaction = db.transaction("groupsQuery", "readwrite")
    const info = transaction.objectStore("groupsQuery")
    const all = info.getAll()

    all.onsuccess = function() {
      allInfo = all.result

      // select relevant information from the retrieved query
      for (var k = 0; k < allInfo.length; k++) {
        if (topTenGroups.includes(allInfo[k].value["Bridge.idGroup"])) {
          groupsTenDescriptions.push(allInfo[k].value["Bridge.idGroup"])
        }
      }
    }
    db.close()
  }
  return groupsTenDescriptions
}

// ------------------------------------------------ TABLE GROUP JOBS ------------------------------------------------ //

// function to retrieve the jobs information of the jobs that are included in group jobs top 10
export function getListJobs() {
  var jobsList = []
  var allInfo

  // establish connection with the database table
  const request = window.indexedDB.open("ioScience", window.version)
  request.onsuccess = function() {
    const db = request.result
    const transaction = db.transaction("jobsQuery", "readwrite")
    const info = transaction.objectStore("jobsQuery")
    const all = info.getAll()

    all.onsuccess = function() {
      allInfo = all.result

      // select relevant information from the retrieved query
      for (var i = 0; i < allInfo.length; i++) {
        if (topTenGroups.includes(allInfo[i].value["Bridge.idGroup"])) {
          jobsList.push(allInfo[i].value)
        }
      }
    }
    db.close()
  }
  return jobsList
}

// ------------------------------------------- TABLE CAE CIRS DESCRIPTION ------------------------------------------- //

// function to retrieve the jobs information of the jobs that are included in group jobs top 10
export function getCaeCirsDescriptions() {
  var caecirsList = []
  var allInfo

  // establish connection with the database table
  const request = window.indexedDB.open("ioScience", window.version)
  request.onsuccess = function() {
    const db = request.result
    const transaction = db.transaction("caecirsQuery", "readwrite")
    const info = transaction.objectStore("caecirsQuery")
    const all = info.getAll()

    all.onsuccess = function() {
      allInfo = all.result

      // select relevant information from the retrieved query
      for (var i = 0; i < allInfo.length; i++) {
        if (topTenCaeCirs.includes(allInfo[i].value["CaeCirs.code"])) {
          caecirsList.push(allInfo[i].value)
        }
      }
    }
    db.close()
  }
  return caecirsList
}

// ---------------------------------------------- LOCATIONS ACTIVITIES ---------------------------------------------- //

// function to retrieve information on the top 10 activities per district
export function getDistrictsActivies() {
  var districtsActivities = []
  var allInfo

  // establish connection with the database table
  const request = window.indexedDB.open("ioScience", window.version)
  request.onsuccess = function() {
    const db = request.result
    const transaction = db.transaction("districtsActivityQuery", "readwrite")
    const info = transaction.objectStore("districtsActivityQuery")
    const all = info.getAll()

    all.onsuccess = function() {
      allInfo = all.result

      // select relevant information from the retrieved query
      for (var i = 0; i < allInfo.length; i++) {
        if (topTenActivities.includes(allInfo[i].value["Activity.activity"])) {
          districtsActivities.push(allInfo[i])
        }
      }
    }
    db.close()
  }
  console.log(districtsActivities)
  return districtsActivities
}

// function to retrieve information on the top 10 activities per city
export function getCitiesActivies() {
  var citiesActivities = []
  var allInfo

  // establish connection with the database table
  const request = window.indexedDB.open("ioScience", window.version)
  request.onsuccess = function() {
    const db = request.result
    const transaction = db.transaction("citiesActivityQuery", "readwrite")
    const info = transaction.objectStore("citiesActivityQuery")
    const all = info.getAll()

    all.onsuccess = function() {
      allInfo = all.result

      // select relevant information from the retrieved query
      for (var i = 0; i < allInfo.length; i++) {
        if (topTenActivities.includes(allInfo[i].value["Activity.activity"])) {
          citiesActivities.push(allInfo[i])
        }
      }
    }
    db.close()
  }
  return citiesActivities
}

// function to retrieve information on the top 10 activities per parish
export function getParishesActivies() {
  var parishesActivities = []
  var allInfo

  // establish connection with the database table
  const request = window.indexedDB.open("ioScience", window.version)
  request.onsuccess = function() {
    const db = request.result
    const transaction = db.transaction("parishActivityQuery", "readwrite")
    const info = transaction.objectStore("parishActivityQuery")
    const all = info.getAll()

    all.onsuccess = function() {
      allInfo = all.result

      // select relevant information from the retrieved query
      for (var i = 0; i < allInfo.length; i++) {
        if (topTenActivities.includes(allInfo[i].value["Activity.activity"])) {
          parishesActivities.push(allInfo[i])
        }
      }
    }
    db.close()
  }
  return parishesActivities
}

// function to form a data series based on a location level and the top 10 activities
export function getLocationActivities(locationLabels, locationActivities, level) {
  var series = []
  for (var i = 0; i < locationLabels.length; i++) {
    var counts = []
    for (var k = 0; k < locationActivities.length; k++) {
      console.log(locationActivities)
      if (locationActivities[k].value[level] === locationLabels[i]) {
        counts.push(locationActivities[k].value["Facts.count"])
      }
    }
    if (counts.length === 0) {
      counts = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    }
    var seriesLine = { name: locationLabels[i], data: counts }
    series.push(seriesLine)
  }
  return series
}

// ------------------------------------------------- TABLE CONTACTS ------------------------------------------------- //

// function to retrieve the contacts information
export function getContactsData() {
  var contacts = []
  var allInfo

  // establish connection with the database table
  const request = window.indexedDB.open("ioScience", window.version)
  request.onsuccess = function() {
    const db = request.result
    const transaction = db.transaction("contactsQuery", "readwrite")
    const mapInfo = transaction.objectStore("contactsQuery")
    const all = mapInfo.getAll()

    all.onsuccess = function() {
      allInfo = all.result

      // select relevant information from the retrieved query
      for (var i = 0; i < allInfo.length; i++) {
        contacts.push(allInfo[i].value)
      }
    }
    db.close()
  }
  return contacts
}

// ------------------------------------------------ MAPS COORDINATES ------------------------------------------------ //

// function to retrieve the contacts information
export function getCoordinatesData() {
  var coordinates = []
  var allInfo

  // establish connection with the database table
  const request = window.indexedDB.open("ioScience", window.version)
  request.onsuccess = function() {
    const db = request.result
    const transaction = db.transaction("mapQuery", "readwrite")
    const mapInfo = transaction.objectStore("mapQuery")
    const all = mapInfo.getAll()

    all.onsuccess = function() {
      allInfo = all.result

      // select relevant information from the retrieved query
      for (var i = 0; i < allInfo.length; i++) {
        coordinates.push({
          label: allInfo[i].value["Company.name"],
          position: {
            lat: allInfo[i].value["Coordinates.latitude"],
            lng: allInfo[i].value["Coordinates.longitude"]
          }
        })
      }
    }
    db.close()
  }
  return coordinates
}

// -------------------------------------------------- CARDS' FACTS -------------------------------------------------- //

// function to retrieve the cards information
export function getCardsData() {
  var allInfo

  // establish connection with the database table
  const request = window.indexedDB.open("ioScience", window.version)
  request.onsuccess = function() {
    const db = request.result
    const transaction = db.transaction("factsQuery", "readwrite")
    const mapInfo = transaction.objectStore("factsQuery")
    const all = mapInfo.getAll()

    all.onsuccess = function() {
      allInfo = all.result

      // change global variables attributed to each card
      window.counter = allInfo[allInfo.length - 1].value["Facts.count"].toString()
      window.actives = allInfo[allInfo.length - 1].value["Facts.isActive"].toString()
      window.registers = allInfo[allInfo.length - 1].value["Facts.isRegistered"].toString()
      window.accounts = allInfo[allInfo.length - 1].value["Facts.hasAccount"].toString()
    }
    db.close()
  }
}

// ----------------------------------------------- GRADIENT PROVIDERS ----------------------------------------------- //

// function to retrieve the jobs information of the jobs that are included in group jobs top 10
export function getProvidersData() {
  var providersPercentage = []
  var allInfo

  // establish connection with the database table
  const request = window.indexedDB.open("ioScience", window.version)
  request.onsuccess = function() {
    const db = request.result
    const transaction = db.transaction("factsQuery", "readwrite")
    const mapInfo = transaction.objectStore("factsQuery")
    const all = mapInfo.getAll()

    all.onsuccess = function() {
      allInfo = all.result

      // select relevant information from the retrieved query
      providersPercentage.push(allInfo[0].value["Facts.providesService"] / allInfo[0].value["Facts.count"] + 0.41 * 100)
    }
    db.close()
  }
  return providersPercentage
}

// ------------------------------------------------- CAE CIRS CHART ------------------------------------------------- //

// function to retrieve top ten most common cae cirs through the companies connected - COUNTS
export var sumCaecirs = 0
export function getCaecirsCounts() {
  var caecirsCounts = []
  var caecirsPercentage = []
  var allInfo

  // establish connection with the database table
  const request = window.indexedDB.open("ioScience", window.version)
  request.onsuccess = function() {
    const db = request.result
    const transaction = db.transaction("caecirsQuery", "readwrite")
    const info = transaction.objectStore("caecirsQuery")
    const all = info.getAll()

    all.onsuccess = function() {
      allInfo = all.result

      // select relevant information from the retrieved query
      for (var k = 0; k < allInfo.length; k++) {
        if (topTenCaeCirs.includes(allInfo[k].value["CaeCirs.code"])) {
          caecirsCounts.push(allInfo[k].value["Facts.count"])
          sumCaecirs = sumCaecirs + allInfo[k].value["Facts.count"]
        }
      }
      for (var j = 0; j < caecirsCounts.length; j++) {
        caecirsPercentage.push(Math.round((caecirsCounts[j] / sumCaecirs) * 100))
      }
    }
    db.close()
  }
  return caecirsPercentage
}

// ------------------------------------------------ CATEGORIES CHART ------------------------------------------------ //

// function to retrieve top ten most common categories through the companies connected - COUNTS
export var sumCategories = 0
export function getCategoriesCounts() {
  var categoriesCounts = []
  var categoriesPercentage = []
  var allInfo

  // establish connection with the database table
  const request = window.indexedDB.open("ioScience", window.version)
  request.onsuccess = function() {
    const db = request.result
    const transaction = db.transaction("categoryQuery", "readwrite")
    const info = transaction.objectStore("categoryQuery")
    const all = info.getAll()

    all.onsuccess = function() {
      allInfo = all.result

      // select relevant information from the retrieved query
      for (var k = 0; k < allInfo.length; k++) {
        if (topTenCategories.includes(allInfo[k].value["Activity.category"])) {
          categoriesCounts.push(allInfo[k].value["Facts.count"])
          sumCategories = sumCategories + allInfo[k].value["Facts.count"]
        }
      }
      for (var j = 0; j < categoriesCounts.length; j++) {
        categoriesPercentage.push(Math.round((categoriesCounts[j] / sumCategories) * 100))
      }
    }
    db.close()
  }
  return categoriesPercentage
}

// ----------------------------------------------- ACTIVITIES' CHARTS ----------------------------------------------- //

// function to retrieve top ten most common categories through the companies connected - COUNTS
export function getActivitiesCounts() {
  var activitiesCounts = []
  var allInfo

  // establish connection with the database table
  const request = window.indexedDB.open("ioScience", window.version)
  request.onsuccess = function() {
    const db = request.result
    const transaction = db.transaction("activityQuery", "readwrite")
    const info = transaction.objectStore("activityQuery")
    const all = info.getAll()

    all.onsuccess = function() {
      allInfo = all.result

      // select relevant information from the retrieved query
      for (var k = 0; k < allInfo.length; k++) {
        if (topTenActivities.includes(allInfo[k].value["Activity.activity"])) {
          activitiesCounts.push(allInfo[k].value["Facts.count"])
        }
      }
    }
    db.close()
  }
  return activitiesCounts
}

// function to retrieve top ten most common categories through the companies connected - COUNTS
export function getActivitiesProviders() {
  var activitiesProviders = []
  var allInfo

  // establish connection with the database table
  const request = window.indexedDB.open("ioScience", window.version)
  request.onsuccess = function() {
    const db = request.result
    const transaction = db.transaction("activityQuery", "readwrite")
    const info = transaction.objectStore("activityQuery")
    const all = info.getAll()

    all.onsuccess = function() {
      allInfo = all.result

      // select relevant information from the retrieved query
      for (var k = 0; k < allInfo.length; k++) {
        if (topTenActivities.includes(allInfo[k].value["Activity.activity"])) {
          activitiesProviders.push(allInfo[k].value["Facts.providesService"])
        }
      }
    }
    db.close()
  }
  return activitiesProviders
}

// -------------------------------------------------- FILTERS DATA -------------------------------------------------- //

// function to retrieve districts filter information
export function getDistricts() {
  var districts = []
  var allInfo

  // estabilish connection with the database
  const request = window.indexedDB.open("ioScience", window.version)
  request.onsuccess = function() {
    const db = request.result
    const transaction = db.transaction("districtsQuery", "readwrite")
    const mapInfo = transaction.objectStore("districtsQuery")
    const all = mapInfo.getAll()

    all.onsuccess = function() {
      allInfo = all.result

      // select relevant information from the retrieved query
      for (var i = 0; i < allInfo.length; i++) {
        districts.push(allInfo[i].value["Location.district"])
      }
    }
    db.close()
  }
  console.log(districts)
  return districts
}

// function to retrieve cities filter information
export function getCities() {
  var cities = []
  var allInfo

  // estabilish connection with the database
  const request = window.indexedDB.open("ioScience", window.version)
  request.onsuccess = function() {
    const db = request.result
    const transaction = db.transaction("citiesQuery", "readwrite")
    const mapInfo = transaction.objectStore("citiesQuery")
    const all = mapInfo.getAll()

    all.onsuccess = function() {
      allInfo = all.result

      // select relevant information from the retrieved query
      for (var i = 0; i < allInfo.length; i++) {
        cities.push(allInfo[i].value["Location.cities"])
      }
    }
    db.close()
  }
  return cities
}

// function to retrieve parishes filter information
export function getParishes() {
  var parishes = []
  var allInfo

  // estabilish connection with the database
  const request = window.indexedDB.open("ioScience", window.version)
  request.onsuccess = function() {
    const db = request.result
    const transaction = db.transaction("parishesQuery", "readwrite")
    const mapInfo = transaction.objectStore("parishesQuery")
    const all = mapInfo.getAll()

    all.onsuccess = function() {
      allInfo = all.result

      // select relevant information from the retrieved query
      for (var i = 0; i < allInfo.length; i++) {
        parishes.push(allInfo[i].value["Location.parishes"])
      }
    }
    db.close()
  }
  return parishes
}

// function to retrieve activities filter information
export function getActivities() {
  var activities = []
  var allInfo

  // estabilish connection with the database
  const request = window.indexedDB.open("ioScience", window.version)
  request.onsuccess = function() {
    const db = request.result
    const transaction = db.transaction("activityQuery", "readwrite")
    const mapInfo = transaction.objectStore("activityQuery")
    const all = mapInfo.getAll()

    all.onsuccess = function() {
      allInfo = all.result

      // select relevant information from the retrieved query
      for (var i = 0; i < allInfo.length; i++) {
        activities.push(allInfo[i].value["Activity.activity"])
      }
    }
    db.close()
  }
  return activities
}

// function to retrieve categories filter information
export function getCategories() {
  var categories = []
  var allInfo

  // estabilish connection with the database
  const request = window.indexedDB.open("ioScience", window.version)
  request.onsuccess = function() {
    const db = request.result
    const transaction = db.transaction("categoryQuery", "readwrite")
    const mapInfo = transaction.objectStore("categoryQuery")
    const all = mapInfo.getAll()

    all.onsuccess = function() {
      allInfo = all.result

      // select relevant information from the retrieved query
      for (var i = 0; i < allInfo.length; i++) {
        categories.push(allInfo[i].value["Activity.category"])
      }
    }
    db.close()
  }
  return categories
}

// function to retrieve categories filter information
export function getCaeCirs() {
  var caecirs = []
  var allInfo

  // estabilish connection with the database
  const request = window.indexedDB.open("ioScience", window.version)
  request.onsuccess = function() {
    const db = request.result
    const transaction = db.transaction("caecirsQuery", "readwrite")
    const mapInfo = transaction.objectStore("caecirsQuery")
    const all = mapInfo.getAll()

    all.onsuccess = function() {
      allInfo = all.result

      // select relevant information from the retrieved query
      for (var i = 0; i < allInfo.length; i++) {
        caecirs.push(allInfo[i].value["CaeCirs.code"])
      }
    }
    db.close()
  }
  return caecirs
}

// ------------------------------------------------- FILTERS UPDATE ------------------------------------------------- //
// Get Data correspondent to the filter applied
export function getFilterData(queryName, filterArray, field) {
  var filter
  const request = window.indexedDB.open("ioScience", window.version)
  request.onsuccess = function() {
    const db = request.result
    const transaction = db.transaction(queryName, "readwrite")
    const mapInfo = transaction.objectStore(queryName)
    const all = mapInfo.getAll()
    all.onsuccess = function() {
      filter = all.result
      for (var i = 0; i < filter.length; i++) {
        filterArray.push(filter[i].value[field])
      }
    }
  }
  return filterArray
}
